export default __webpack_public_path__ + "static/media/layout_circle_img.e97ef78e.svg";